import { render, staticRenderFns } from "./token-debug.vue?vue&type=template&id=404a4fff&scoped=true"
import script from "./token-debug.vue?vue&type=script&lang=js"
export * from "./token-debug.vue?vue&type=script&lang=js"
import style0 from "./token-debug.vue?vue&type=style&index=0&id=404a4fff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404a4fff",
  null
  
)

export default component.exports